
$(document).ready(function () {
    $(this).find('title').remove();
    $(this).find('meta[name="title"]').remove();
    $(this).find('meta[name="description"]').remove();
    $(this).find('meta[name="keywords"]').remove();
    $("head").append("<title>" + $('#title_after').val() + "</title>");

    var metatitle = "<meta name='title' content=\"" + $("#meta_title").val() + "\">";
    $("head").append(metatitle);
    var metaname = "<meta name='description' content=\"" + $("#MetaDescription").val() + "\">";
    $("head").append(metaname);
    var metakeywords = "<meta name='keywords' content=\"" + $("#MetaKeywords").val() + "\">";
    $("head").append(metakeywords);

});